import React from "react"
import Footer from "../components/footer"
import Navbar from "../components/nav"

function ClashTrophyTerms() {
  return (
    <>
      <header className="header-area">
        <div className="navbar-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Navbar />
              </div>
            </div>
          </div>
        </div>
      </header>

      <div id="home">
        <div className="container mt-125 mb-50">
          <div className="card-body shadow">
            <h4>Terms & Conditions - ClashTrophy</h4>
            <br />
            <ul>
              <li>THE DEVELOPER = MWX Apps</li>
              <li>THE APP = ClashTrophy - Clash Royale Stats & Deck Builder</li>
              <li>PACKAGE = com.clashtrophy</li>
            </ul>
            <br />
            <p>
              By downloading or using THE APP, these terms will automatically apply
              to you – you should make sure therefore that you read them carefully
              before using THE APP. You're not allowed to copy, or modify THE APP,
              any part of THE APP, or our trademarks in any way. You're not allowed
              to attempt to extract the source code of THE APP, and you also
              shouldn't try to translate THE APP into other languages, or make
              derivative versions. THE APP itself, and all the trade marks,
              copyright, database rights and other intellectual property rights
              related to it, still belong to THE DEVELOPER.
            </p>
            <p>
              THE DEVELOPER is committed to ensuring that THE APP is as useful and
              efficient as possible. For that reason, we reserve the right to make
              changes to THE APP or to charge for its services, at any time and for
              any reason. We will never charge you for THE APP or its services
              without making it very clear to you exactly what you're paying for.
            </p>

            <br />
            <strong>What ClashTrophy Does</strong>
            <p>
              ClashTrophy provides live Clash Royale stats, deck builder, clan war
              tracker, win rates and meta tiers by fetching <strong>public game data</strong>
              from the official Clash Royale API and community APIs (e.g., RoyaleAPI).
              When you enter a player tag, clan tag or deck search, THE APP sends
              only that public identifier via HTTPS and displays the returned public
              data. Deck builder drafts, favorites and recent searches are stored
              <strong> locally on your device only</strong> and are never stored on our servers.
            </p>
            <p>
              <strong>Not affiliated with Supercell:</strong> Clash Royale and all
              related assets are trademarks of Supercell Oy. ClashTrophy is an
              independent, fan-made stats companion and is not affiliated with,
              endorsed or sponsored by Supercell. For Supercell's terms, see
              https://supercell.com/en/terms-of-service/ .
            </p>

            <br />
            <strong>Eligibility</strong>
            <p>
              THE APP is available to users of all ages, but if you are under 13,
              please use it only with parental guidance. No account registration is
              required and we do not knowingly collect personal information from children.
            </p>

            <br />
            <strong>License and Permitted Use</strong>
            <p>
              THE DEVELOPER grants you a limited, non-exclusive, non-transferable,
              revocable license to use THE APP on your Android device for personal,
              non-commercial use. You agree NOT to:
            </p>
            <ul>
              <li>Copy, modify, distribute, sell or lease any part of THE APP</li>
              <li>Reverse engineer, decompile or attempt to extract the source code</li>
              <li>Remove or obscure any proprietary notices</li>
              <li>Use THE APP for any illegal or unauthorized purpose</li>
              <li>Attempt to bypass API rate limits or abuse the Clash Royale API / RoyaleAPI</li>
              <li>Use bots, scrapers or automated means to harvest data beyond normal use</li>
              <li>Upload viruses, malware or harmful code</li>
            </ul>

            <br />
            <strong>Intellectual Property</strong>
            <p>
              THE APP and its original content, design, features and code are the
              exclusive property of THE DEVELOPER and are protected by copyright and
              trademark laws of Turkey and other countries. Clash Royale game content,
              card images, names and stats belong to Supercell and are used under
              fair use for informational purposes. Our trademarks and trade dress may
              not be used without prior written consent.
            </p>

            <br />
            <strong>Data Accuracy Disclaimer</strong>
            <p>
              <strong>IMPORTANT:</strong> All stats, win rates, meta tiers and clan war
              data are sourced from public APIs and community aggregates. While we
              strive for freshness and accuracy, THE DEVELOPER does not guarantee that
              data will always be up-to-date, error-free or complete. APIs may have
              delays, caching or downtime. Meta tiers are statistical estimates, not
              guarantees of battle outcomes.
            </p>
            <p>
              Do not rely solely on THE APP for competitive decisions, betting or
              financial purposes. THE DEVELOPER accepts no liability for any loss,
              direct or indirect, you experience as a result of relying on stats,
              deck recommendations or win-rate predictions.
            </p>

            <br />
            <strong>Third-Party Services</strong>
            <p>
              THE APP uses third-party APIs to provide live data:
            </p>
            <ul>
              <li><strong>Clash Royale API (Supercell)</strong> – https://developer.clashroyale.com/</li>
              <li><strong>RoyaleAPI</strong> – https://royaleapi.com/</li>
            </ul>
            <p>
              Your use of data from these services is subject to their respective
              terms and privacy policies. We have no control over and assume no
              responsibility for their content, availability or practices. THE APP
              does NOT use Google Analytics, Firebase Analytics, Facebook SDK or
              advertising profiling SDKs. Google Play Services distribution is governed
              by Google's Terms.
            </p>

            <br />
            <strong>Internet and Device Requirements</strong>
            <p>
              Live stats require an active internet connection (Wi-Fi or mobile data).
              THE DEVELOPER cannot take responsibility for THE APP not working at
              full functionality if you lack connectivity or data allowance. If you
              use THE APP outside Wi-Fi, your mobile provider's terms and charges
              apply, including roaming charges. You are responsible for such charges.
            </p>
            <p>
              It's your responsibility to keep your phone and access to THE APP
              secure. We recommend that you do not jailbreak or root your phone, as
              it could make your device vulnerable to malware and cause THE APP to
              malfunction. Keep your device charged – THE DEVELOPER cannot be
              responsible if you cannot access THE APP due to battery loss.
            </p>

            <br />
            <strong>Privacy</strong>
            <p>
              Your privacy is important to us. Our collection and use of information
              is governed by our{" "}
              <a href="/clashtrophy/privacy-policy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
              . By using THE APP you consent to the practices described therein.
              Key points: no personal data collected, only public player/clan tags
              are transmitted to APIs, no tracking, all favorites/history stored
              locally.
            </p>

            <br />
            <strong>Disclaimers and Warranties</strong>
            <p>
              THE APP IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT
              WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
              LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
              PARTICULAR PURPOSE, NON-INFRINGEMENT OR COURSE OF PERFORMANCE. THE
              DEVELOPER does not warrant that THE APP will be uninterrupted,
              error-free, secure or that defects will be corrected.
            </p>

            <br />
            <strong>Limitation of Liability</strong>
            <p>
              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
              THE DEVELOPER, ITS DIRECTORS, EMPLOYEES, PARTNERS, AGENTS, SUPPLIERS OR
              AFFILIATES BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
              CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION LOSS OF
              PROFITS, DATA, USE, GOODWILL OR OTHER INTANGIBLE LOSSES, RESULTING FROM
              (a) YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE APP;
              (b) ANY CONDUCT OR CONTENT OF ANY THIRD PARTY ON THE APP; (c) ANY
              CONTENT OBTAINED FROM THE APP; (d) UNAUTHORIZED ACCESS OR ALTERATION;
              (e) RELIANCE ON STATS, WIN RATES, META TIERS OR DECK RECOMMENDATIONS.
            </p>

            <br />
            <strong>Updates and Termination</strong>
            <p>
              At some point, we may wish to update THE APP. THE APP is currently
              available on Android – the requirements for system (and for any
              additional systems we decide to extend the availability of THE APP to)
              may change, and you'll need to download the updates if you want to keep
              using THE APP. THE DEVELOPER does not promise that it will always
              update THE APP so that it is relevant to you and/or works with the
              Android version that you have installed on your device. However, you
              promise to always accept updates to THE APP when offered to you. We may
              also wish to stop providing THE APP, and may terminate use of it at any
              time without giving notice of termination to you. Unless we tell you
              otherwise, upon any termination, (a) the rights and licenses granted to
              you in these terms will end; (b) you must stop using THE APP, and (if
              needed) delete it from your device.
            </p>

            <br />
            <strong>Governing Law</strong>
            <p>
              These Terms shall be governed and construed in accordance with the laws
              of Turkey, without regard to its conflict of law provisions. Any disputes
              shall be submitted to the competent courts of Turkey.
            </p>

            <br />
            <strong id="changes-to-these-terms-and-conditions">
              <a
                aria-hidden="true"
                href="#changes-to-these-terms-and-conditions"
                tabindex="-1"
              >
                <span class="icon icon-link"></span>
              </a>
              Changes to These Terms and Conditions
            </strong>
            <p>
              We may update our Terms and Conditions from time to time. Thus, you are
              advised to review this page periodically for any changes. We will
              notify you of any changes by updating the "Last Updated" date. These changes
              are effective immediately after they are posted on this page.
              This policy is effective as of September 02, 2026.
            </p>

            <br />
            <strong id="contact-us">
              <a aria-hidden="true" href="#contact-us" tabindex="-1">
                <span class="icon icon-link"></span>
              </a>
              Contact Us
            </strong>
            <p>
              If you have any questions or suggestions about these Terms and
              Conditions, do not hesitate to contact us at: web-developer@outlook.com
            </p>
            <p className="mt-2"><strong>Developer:</strong> MWX Apps</p>
            <p><strong>App:</strong> ClashTrophy (com.clashtrophy)</p>
            <p><strong>Website:</strong> https://mwx-apps.web.app/clashtrophy</p>
            <p className="mt-2"><em>Clash Royale is a trademark of Supercell Oy. This app is not affiliated with Supercell.</em></p>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default ClashTrophyTerms
